import { isRpaPayer } from './payerRouting'
import { isMemberIdOptionalForPayer } from '../../shared/stediPayerRegistry'

/** The manual-form fields the submission gate reads. */
export interface ManualCheckGateFields {
  firstName: string
  lastName: string
  memberId: string
  payerName: string
  tradingPartnerServiceId: string
  stediPayerId: string | null
}

/**
 * RPA-routed payers (VSP, EyeMed) run through portal scrapers which look up
 * eligibility by demographics, not by member ID. Some Stedi payers also
 * accept 270 requests without a memberId — the shared registry is the
 * source of truth for which ones. The registry is keyed by Stedi's stable
 * `stediId`, not the `tradingPartnerServiceId` (primary payer ID) we send
 * on the 270 — they're different fields and only `stediId` is guaranteed
 * stable across directory updates.
 */
export function isManualMemberIdOptional(form: ManualCheckGateFields): boolean {
  return isRpaPayer(form) || isMemberIdOptionalForPayer(form.stediPayerId)
}

/**
 * Check-button gate for the manual eligibility form.
 *
 * A provider is required for EVERY payer, vision included: the
 * verifyEligibility callable rejects any request without a providerId
 * before route resolution, so letting an RPA-routed submission through
 * without one just trades a disabled button for a server error.
 */
export function canSubmitManualCheck(form: ManualCheckGateFields, selectedProviderId: string): boolean {
  return Boolean(
    form.firstName && form.lastName
    && form.tradingPartnerServiceId
    && (isManualMemberIdOptional(form) || form.memberId)
    && selectedProviderId,
  )
}
